module.exports = __webpack_public_path__ + "files/7398a789207ab09fd1e271b336a98e55.png";